// reppenrundung
export default (price) => {
  return Math.round(price * 20) / 20
}
